import React, { useEffect, useMemo } from "react";
import "../sass/components/modalPlanos.scss";

const parseNumeroBR = (valor) => {
  if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;
  const texto = String(valor ?? "0").trim();
  const normalizado = texto.includes(",")
    ? texto.replace(/\./g, "").replace(",", ".")
    : texto;
  const numero = Number(normalizado.replace(/[^0-9.-]/g, ""));
  return Number.isFinite(numero) ? numero : 0;
};

const moedaBR = (valor) =>
  parseNumeroBR(valor).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const ModalPlanos = ({ planos = {}, onClose }) => {
  const lista = useMemo(() => {
    if (Array.isArray(planos)) return planos;
    if (Array.isArray(planos?.planos)) return planos.planos;
    if (Array.isArray(planos?.data)) return planos.data;
    return [];
  }, [planos]);

  const totalCalculado = lista.reduce(
    (soma, item) => soma + parseNumeroBR(item?.ValorCobrado ?? item?.valor),
    0,
  );
  const total = planos?.total ?? totalCalculado;

  useEffect(() => {
    const onKey = (event) => event.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-planos-overlay" onMouseDown={onClose}>
      <section
        className="modal-planos"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-planos-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="modal-planos-header">
          <div>
            <span className="modal-planos-eyebrow">Contrato</span>
            <h2 id="modal-planos-title">Planos assinados</h2>
            <p>Produtos e serviços vinculados ao cadastro do cliente.</p>
          </div>
          <button type="button" className="modal-planos-close" onClick={onClose} aria-label="Fechar">×</button>
        </header>

        <div className="modal-planos-summary">
          <div><span>Planos ativos</span><strong>{lista.length}</strong></div>
          <div><span>Valor total</span><strong>{moedaBR(total)}</strong></div>
        </div>

        <div className="modal-planos-table-wrap">
          <table className="tabela-planos">
            <thead><tr><th>Descrição</th><th>Valor cobrado</th></tr></thead>
            <tbody>
              {lista.length === 0 ? (
                <tr><td colSpan={2} className="modal-planos-empty">Nenhum plano localizado para este cliente.</td></tr>
              ) : lista.map((plano, index) => (
                <tr key={plano?.ID ?? plano?.id ?? `${plano?.Plano || "plano"}-${index}`}>
                  <td><strong>{plano?.Plano ?? plano?.descricao ?? plano?.Descricao ?? "Plano sem descrição"}</strong></td>
                  <td>{moedaBR(plano?.ValorCobrado ?? plano?.valor)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <footer className="modal-planos-footer">
          <button type="button" onClick={onClose}>Fechar</button>
        </footer>
      </section>
    </div>
  );
};

export default ModalPlanos;
